import Image from 'next/image'
import { tm } from '@captaincause/ui/tm'
import dLogo from 'assets/dift-small-black.svg'
import { Button } from 'components/Button'
import { LocalizationToggle } from 'components/LocalizationToggle'
import { SmallFooter } from 'components/SmallFooter'
import type { LayoutProps } from './App'
import type { Localization } from '@captaincause/types'

interface LightHeaderProps {
  localizations: Localization[]
}
const LightHeader = ({ localizations }: LightHeaderProps) => (
  <header
    id="header"
    data-testid="footer"
    className="z-10 flex h-16 items-center justify-between gap-8 border border-light-gray bg-white p-2"
  >
    <Button
      href="https://dift.com"
      variant="raw"
      className="mt-2 block h-auto w-[64px] md:ml-2 md:mt-0 md:p-0"
    >
      <Image src={dLogo} alt="Dift" style={{ width: '32px', height: '32px' }} />
    </Button>
    <LocalizationToggle localizations={localizations} />
  </header>
)

export function LightNavAndSmallFooterLayout({
  children,
  pageProps = undefined,
  className = '',
}: LayoutProps) {
  return (
    <div id="layout" className={tm(className, 'flex flex-col')}>
      <LightHeader localizations={pageProps?.localizations ?? []} />
      {children}
      <SmallFooter />
    </div>
  )
}
